var _path, _rect, _rect2, _rect3, _path2, _rect4, _path3, _circle, _path4, _circle2, _path5, _circle3, _path6, _polygon, _circle4, _path7, _path8, _rect5, _path9, _rect6, _path10, _path11, _polygon2, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrueFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 655.86,
    height: 506.44,
    viewBox: "0 0 655.86 506.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m350.22,378.66c-1.77,10.71-11.09,18.91-22.29,18.91s-20.53-8.2-22.29-18.91h-57.04v123.61h158.66v-123.61h-57.04,0Z",
    fill: "#dfdfdf",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 251.36,
    y: 501.81,
    width: 15.68,
    height: 2.77,
    fill: "#bcb9cb",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 390.19,
    y: 502.27,
    width: 15.68,
    height: 2.77,
    fill: "#bcb9cb",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 249.06,
    y: 492.47,
    width: 158.66,
    height: 4.3,
    fill: "#2f2e41",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m647.01,381.89H8.85c-4.88,0-8.85-3.97-8.85-8.85V8.85C0,3.97,3.97,0,8.85,0h638.16c4.88,0,8.85,3.97,8.85,8.85v364.2c0,4.88-3.97,8.85-8.85,8.85h0Z",
    fill: "#2f2e41",
    strokeWidth: 0
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.14,
    y: 15.68,
    width: 624.49,
    height: 352.37,
    fill: "#fff",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m328.75,129.57h-38.41c-12.07,0-21.89-9.82-21.89-21.89s9.82-21.89,21.89-21.89h38.41c12.07,0,21.89,9.82,21.89,21.89s-9.82,21.89-21.89,21.89Z",
    fill: "#dfdfdf",
    strokeWidth: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 291.11,
    cy: 107.68,
    r: 16.9,
    fill: "#fff",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m328.75,280.44h-38.41c-12.07,0-21.89-9.82-21.89-21.89s9.82-21.89,21.89-21.89h38.41c12.07,0,21.89,9.82,21.89,21.89s-9.82,21.89-21.89,21.89Z",
    fill: "#dfdfdf",
    strokeWidth: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.11,
    cy: 258.55,
    r: 16.9,
    fill: "#fff",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m328.75,204.86h-38.41c-12.07,0-21.89-9.82-21.89-21.89s9.82-21.89,21.89-21.89h38.41c12.07,0,21.89,9.82,21.89,21.89s-9.82,21.89-21.89,21.89Z",
    fill: "#dfdfdf",
    strokeWidth: 0
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.56,
    cy: 182.97,
    r: 16.9,
    fill: "#3081d0",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m149,505.53c0,.5.4.91.91.91h356.03c.5,0,.91-.4.91-.91s-.4-.91-.91-.91H149.91c-.5,0-.91.4-.91.91Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "398.94 198.22 382 203.79 382 179.4 397.37 179.4 398.94 198.22",
    fill: "#f2a7aa",
    strokeWidth: 0
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.1,
    cy: 169.27,
    r: 16.88,
    fill: "#f2a7aa",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m388.73,167.6c-2.83-.09-4.68-2.94-5.78-5.55s-2.23-5.6-4.85-6.68c-2.14-.88-5.92,5.07-7.62,3.48-1.76-1.65-.04-10.13,1.83-11.66s4.43-1.82,6.84-1.93c5.88-.27,11.8.2,17.57,1.41,3.57.74,7.24,1.86,9.81,4.44,3.26,3.27,4.09,8.21,4.33,12.82.24,4.72-.03,9.66-2.33,13.79-2.3,4.13-7.1,7.18-11.7,6.12-.46-2.5,0-5.07.19-7.61.18-2.54,0-5.28-1.56-7.31s-4.86-2.82-6.67-1.03",
    fill: "#36344e",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m409.5,173.45c1.69-1.24,3.71-2.27,5.79-2.02,2.25.27,4.14,2.12,4.72,4.31s-.07,4.6-1.46,6.39c-1.39,1.79-3.45,2.97-5.64,3.56-1.26.34-2.65.48-3.85-.03-1.78-.76-2.73-3.03-2.04-4.84",
    fill: "#36344e",
    strokeWidth: 0
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 377.48,
    y: 469.58,
    width: 15.87,
    height: 22.51,
    fill: "#f2a7aa",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m362.02,505.72c-1.67,0-3.15-.04-4.27-.14-4.22-.39-8.24-3.5-10.26-5.32-.91-.82-1.2-2.12-.73-3.24h0c.34-.81,1.02-1.41,1.86-1.65l11.14-3.18,18.04-12.17.2.36c.08.13,1.85,3.32,2.44,5.48.23.82.17,1.5-.18,2.03-.24.37-.57.58-.84.7.33.34,1.35,1.03,4.5,1.54,4.6.73,5.57-4.04,5.61-4.24l.03-.16.14-.09c2.19-1.41,3.54-2.05,4-1.91.29.09.78.23,2.08,13.22.13.41,1.05,3.4.42,6.25-.68,3.11-14.26,2.04-16.97,1.79-.08,0-10.25.73-17.21.73h0Z",
    fill: "#36344e",
    strokeWidth: 0
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 429.82,
    y: 454.38,
    width: 15.87,
    height: 22.51,
    transform: "translate(-180.09 302.19) rotate(-31.95)",
    fill: "#f2a7aa",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m420.65,502.63c-1.86,0-3.57-.22-4.79-.44-1.2-.21-2.14-1.16-2.33-2.37h0c-.14-.86.12-1.73.7-2.38l7.77-8.59,8.86-19.87.36.2c.14.07,3.33,1.84,4.97,3.36.63.58.94,1.19.93,1.82,0,.44-.17.79-.34,1.04.46.12,1.69.16,4.63-1.08,4.29-1.81,2.59-6.37,2.51-6.56l-.06-.15.07-.15c1.11-2.36,1.91-3.61,2.38-3.74.29-.08.78-.21,8.76,10.11.33.27,2.69,2.33,3.67,5.08,1.07,3-11.02,9.27-13.45,10.5-.07.06-12.73,9.26-17.92,11.87-2.06,1.04-4.5,1.36-6.72,1.36h0Z",
    fill: "#36344e",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m405.03,281.31h-44.43l-4.03,41.33,17.64,152.71h22.68l-9.07-88.2,36.79,79.63,20.16-14.11-28.73-74.34s10.26-64.76,2.2-80.89c-8.06-16.13-13.21-16.13-13.21-16.13h0Z",
    fill: "#36344e",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "427.13 283.83 356.57 283.83 377.74 192.6 408.48 192.6 427.13 283.83",
    fill: "#3081d0",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-7f4403b9-21a6-4777-8daf-6db0c322735b-89-385",
    d: "m339.05,190.81c-1.13-5.55.94-10.62,4.6-11.32,3.67-.7,7.55,3.23,8.68,8.78.48,2.21.41,4.5-.22,6.69l4.46,23.57-11.53,1.82-3.17-23.43c-1.43-1.79-2.4-3.88-2.82-6.11h0Z",
    fill: "#f2a7aa",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m407.73,192.6h-27.11l-18.28,36.55-6.89-27.39-15.15,1.61s3.58,53.52,19.25,51.71,52.2-50.03,48.18-62.48h0Z",
    fill: "#3081d0",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-4f4c8d73-174a-4aab-b932-a11e56a3b943-90-386",
    d: "m438.01,331.62c1.13,5.55-.94,10.62-4.6,11.32-3.67.7-7.55-3.23-8.68-8.78-.48-2.21-.41-4.5.22-6.69l-4.46-23.57,11.53-1.82,3.17,23.43c1.43,1.79,2.4,3.88,2.82,6.11h0Z",
    fill: "#f2a7aa",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m392.28,192.6s15.41-.65,16.21,0c4.2,3.44,28.87,127.34,28.87,127.34h-15.62l-29.45-127.34h0Z",
    fill: "#3081d0",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueFalse);
export default __webpack_public_path__ + "static/media/true_false.c729581972ce971ea907510b870305b5.svg";
export { ForwardRef as ReactComponent };